import { Textarea } from "@/components/ui/textarea";
import { AnswerSubCategoryDetail } from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";
import EvaluationRadioGroup from "@/src/console/(auth)/_components/CheckingAssessment/AnswerContent/EvaluationRadioGroup";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface AssessorCheckItemProps {
  contentIndex: number;
  evaluationIndex: number;
}

function AssessorCheckItem({
  evaluationIndex,
  contentIndex,
}: AssessorCheckItemProps) {
  const { control } = useFormContext<AnswerSubCategoryDetail>();
  const { t } = useTranslation();

  const {
    field: { value },
  } = useController({
    control,
    name: `answer_contents.${contentIndex}.answer_evaluations.${evaluationIndex}.content`,
  });

  const {
    field: { value: comment, onChange: onCommentChange },
  } = useController({
    control,
    name: `answer_contents.${contentIndex}.answer_evaluations.${evaluationIndex}.comment`,
  });

  return (
    <div className=" flex flex-col space-y-4">
      <p className=" text-sm font-normal text-cool-gray-700">
        {evaluationIndex + 1}、 {value}
      </p>
      <EvaluationRadioGroup
        evaluationIndex={evaluationIndex}
        contentIndex={contentIndex}
      />
      <Textarea
        value={comment ?? ""}
        onChange={(e) => onCommentChange(e.target.value)}
        className="grow"
        placeholder={t("assessor-memo")}
      />
    </div>
  );
}

export default AssessorCheckItem;
